import { useAuth } from "context/AuthContextProvider";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { LOCAL_STORAGE } from "shared/constants";
import PATHS from "shared/constants/paths";

/**
 * Auth gate — keeps signed-in users off the auth pages. Each auth page brings
 * its own full-page chrome (Login: split editorial layout; the forget-password
 * flow: centered card — see pages/auth/AuthUi.tsx).
 *
 * The redirect goes to HOME with `replace` (HomeRedirect then picks Dashboard
 * or Bisnis by role). Right after signing in the stack is [/login, /dashboard];
 * Back lands here and the replace collapses it to [/dashboard], so the next
 * Back leaves the app. The previous push to /schedule made Back land on Jadwal
 * and re-bounce on every further Back, trapping the admin on that entry.
 */
const AuthLayout = () => {
  const { state } = useAuth();
  let location = useLocation();

  if (location.pathname === PATHS.HOME) {
    return <Navigate to={PATHS.LOGIN} />;
  }

  // On a hard reload the provider starts empty and restores the stored session
  // in an effect, so the login form would paint for one frame before the
  // redirect below fires. Render nothing for that frame — but only while a
  // session is actually stored: after sign-out `isLoading` is ALSO true
  // (DELETE_TOKEN sets it) with storage cleared, and the form must render then.
  if (state.isLoading && localStorage.getItem(LOCAL_STORAGE.TOKEN)) return null;

  if (state.user) return <Navigate to={PATHS.HOME} replace />;

  return <Outlet />;
};

export default AuthLayout;
